export const employeeFinanceDataErrors = [
  {
    field: "moneyDate",
    errors: [
      {
        error: "required",
        message: "Required",
      },
      {
        error: "invalidDate",
        message: "Invalid date",
      },
      {
        error: "dateNotInFuture",
        message: "Date cannot be in the future",
      },
    ],
  },
  {
    field: "moneyValue",
    errors: [
      {
        error: "required",
        message: "Required",
      },
    ],
  },
  {
    field: "moneyExpiryDate",
    errors: [
      {
        error: "invalidDate",
        message: "Invalid date",
      },
    ],
  },
  {
    field: "description",
    errors: [
      {
        error: "required",
        message: "Required",
      },
    ],
  },
];
